import { COMMON_CHUNK_NAME } from '../../../const/generator';

import {
  BuilderComponentPlugin,
  BuilderComponentPluginFactory,
  ChunkType,
  FileType,
  ICodeStruct,
  IContainerInfo,
} from '../../../types';

export interface PluginConfig {
  fileType: string;
  moduleFileType: string;
}

const pluginFactory: BuilderComponentPluginFactory<PluginConfig> = (config?) => {
  const cfg: PluginConfig = {
    fileType: FileType.CSS,
    moduleFileType: FileType.TSX,
    ...config,
  };

  const plugin: BuilderComponentPlugin = async (pre: ICodeStruct) => {
    const next: ICodeStruct = {
      ...pre,
    };

    const ir = next.ir as IContainerInfo;

    // 检查 CSS 内容是否为空（null、undefined、空字符串或仅包含空白字符）
    const hasCssContent = ir.css && ir.css.trim().length > 0;

    // 只有当 CSS 内容不为空时才生成 CSS 文件和对应的导入语句
    if (hasCssContent) {
      next.chunks.push({
        type: ChunkType.STRING,
        fileType: cfg.fileType,
        name: COMMON_CHUNK_NAME.StyleCssContent,
        content: ir.css,
        linkAfter: [COMMON_CHUNK_NAME.StyleDepsImport],
      });

      next.chunks.push({
        type: ChunkType.STRING,
        fileType: cfg.moduleFileType,
        name: COMMON_CHUNK_NAME.InternalDepsImport,
        content: `import './index.${cfg.fileType}';`,
        linkAfter: [COMMON_CHUNK_NAME.ExternalDepsImport],
      });
    }

    return next;
  };
  return plugin;
};

export default pluginFactory;
